import React,{useState,useRef} from 'react';
import '../gestrela.css';
import ReactToPrint from 'react-to-print';
import {ComponentToPrint} from './Print';
import DatePicker from 'react-date-picker';
import CheckitB from './checkbox';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import RConsumo from './RConsumo';
import ReactToExcel from 'react-html-table-to-excel';
import { Relatoriocobranca } from './Relatoriocobranca';
import Rquantidade from './Rquantidade';
import { Relatoriodesempenho } from './Relatoriodesempenho';
import { RelatorioDivida } from './RelatorioDivida';
import { RegistoOperacoes } from './RegistoOperacoes';
import {Protegerotas} from './protegerotas';
import axios from 'axios';
import RMontante from './RMontante';
import ConsumoCliente from './consumocliente';
import RConsumoExcessivo from './RConsumoExcessivo';
import RConsumoInade from './RconsumoInade';
import RConsumonull from './RConsumonull';
import RHistorico from './RHistorico';
import RDelete from './RDelete';
import Rvendas from './Rvendas';
import Rtotal from './Rtotal';
import Rdividas from './Rdividas';
function AGestRelatorios(){
    const [valori,onChange]=useState(new Date());
    const [valorf,onChangef]=useState(new Date());
  const [Operacoes,setOperacoes]=useState(null);
  const [Acessois,setAcesso]=useState(null)
  const printRelaResumo=useRef();
  const [step,setStep]=useState({iva:"",m3:"",valg:"",tsc:"",mpag:""});
  const [value, SonChange] = useState(new Date());
  const [fvalue, fSonChange] = useState(new Date());
  const [desempenho,setDesenpenho]=useState(null);
  const [divida,setDivida]=useState(null);
  const [cobranca,setCobranca]=useState();
  const [rvenda,setRvenda]=useState(null);
  const [Plataforma,setPlataforma]=useState(null);
  const [Revendedor,serRevendedor]=useState(null);
  const [diaano,setDiaAno]=useState(new Date());
  const [diaanofim,setDianofim]=useState(new Date());
  const [dados,setDados]=useState({nrcliente:"",nome:"",bi:"",nuit:"",morada:"",email:"",telemovel:""});
  const [Data,setData]=useState("");
  const printContents = useRef(null);
    
  const [operador,setoperador]=useState(null);
  const [tokens,setTokens]=useState(null);
  const [error,setError]=useState(null);
  const PrintCaixa=useRef();
  const[open,setOpen]=useState(false);
  const [rela,setRela]=useState(null);
  const[relaconsumo,setRelaconsumo]=useState(null);
  const[relaadiqui,setReladiqui]=useState(null)
  const[relavolum,setRelavolum]=useState(null)
  const[relaconsumototal,setRelaconsumototal]=useState(null)
  const [relaConsumoExc,setConsumoExc]=useState(null);
  const [relaconsumoInade,setConsumoInade]=useState(null);
  const [relaconsumonull,setConsumonull]=useState(null);
  const [relaHistoricoR,setHistoricoR]=useState(null);
  const [relaDelete,setRDelete]=useState(null);
  const [relavendas,setRelavendas]=useState(null);
  const [relacliente,setRelacliente]=useState(null);
const [VendaRecarga,setVendaRecarga]=useState(null);
const [relatotal,setRelatotal]=useState(null);
  const Send=(e)=>{

  }
  const MONHandler=(e)=>{
    e.preventDefault();

  }
  const RevHandler=(e)=>{
    e.preventDefault();
    setAcesso(null)
    setOpen(!open);
   setVendaRecarga(null);
    setPlataforma(null);
    setOperacoes('df')

    
  }
  const AcessHandler=(e)=>{
    e.preventDefault();
    setAcesso('sd')
    
    setRvenda(null);
   setVendaRecarga(null);
    setPlataforma(null);
    setOperacoes(null)
    setCobranca(null);
    setDesenpenho(null);
    setDivida(null);
  }
  const Search=(row)=>{
       
    return row.filter((row)=>
    row.metodo.toLowerCase().indexOf(Data)>-1)
}
  const CobHandler=(e)=>{
   setCobranca('er');
   setOpen(false);
   setRvenda(null);
   setVendaRecarga(null);
   setPlataforma(null);
   setDesenpenho(null);
   setDivida(null);
  }
  const desHandler=(e)=>{
    setCobranca(null);
    setDesenpenho('dfdf');
    setDivida(null);
    setOpen(false);
    setRvenda(null);
   setVendaRecarga(null);
    setPlataforma(null);
  }
  
  const divHandler=(e)=>{
    setCobranca(null);
    setDesenpenho(null);
    setDivida('sds');
    setOpen(false);
    setRvenda(null);
   setVendaRecarga(null);
    setPlataforma(null);
  }
  const VendHandler=(e)=>{
    setAcesso(null);
    setCobranca(null);
    setDesenpenho(null);
    setDivida(null);
    setRvenda('dfdf')
    
   setVendaRecarga(null);
    setPlataforma(null);
  }
  const PlataformabHandler=(e)=>{
    setAcesso(null);
    setCobranca(null);
    setDesenpenho(null);
    setDivida(null);
    
    setoperador(null);
    
    setPlataforma('dfd');
   setVendaRecarga(null);
  }
  const SearchD=(row)=>{
    let idado=new Date(diaano)
let fdados=new Date (diaanofim)
idado=idado.getTime()
fdados=fdados.getTime()
console.log(idado)
console.log(fdados)
return row.filter((row)=>
idado<=(new Date(row.data_de_compra)).getTime() && (new Date(row.data_de_compra)).getTime() <=fdados);
    
}
  const OperadorHandler=(e)=>{
    setAcesso(null);
    setCobranca(null);
    setDesenpenho(null);
    setDivida(null);
    setPlataforma(null);
    
     setVendaRecarga(null);
   setoperador('fgf');
    
  }
  const Tokens_recargas=()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/TokensRecarga`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{id:'1'}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( d=>{
        console.log(d.data);
        setTokens(d.data)
    }
   
       ).catch(e=>{
        setError(e.message );
    })

}
  const gerarecargaHandler=(e)=>{
    e.preventDefault();
    setAcesso(null)
    Tokens_recargas();   
    setPlataforma(null);
    setOperacoes(null)
    setCobranca(null);
    setDesenpenho(null);
    setDivida(null);
    setRvenda(null);
   setVendaRecarga('dff');
  }
  const Handler=(e)=>{
    if(rela==='consumdo'){
      setRelaconsumo('dfdf')
      setReladiqui(null);
      setRelavolum(null);
      setRelatotal(null);
      setRelacliente(null);
      setRelaconsumototal(null);

    }
    if(rela==='quantidade'){
      setReladiqui('sdsd');
      setRelaconsumo(null);
      setRelatotal(null);
      setRelaconsumototal(null);
      setRelavolum(null);
      setRelavendas(null);
      setRelacliente(null);
      setRelaconsumo(null);
    }
    if(rela==='adiquirido'){
      setReladiqui(null);
      setRelaconsumo(null);
      setRelavendas(null);
      setRelatotal(null);
      setRelacliente(null);
      setRelaconsumototal(null);
     setRelavolum('dfdf');
    }
    if(rela==='consumo'){
      setReladiqui(null);
      setRelaconsumo(null);
      setRelavolum(null);
      setRDelete(null);
      setRvenda(null);
      setRelatotal(null);
      setRelacliente(null);
      setRelavendas(null);
      setRelaconsumo(null);
      setRelaconsumototal('ds');
    }
    if (rela=="consumo_excessivo"){
      setConsumoExc('ds');
      setConsumoInade(null);
      setConsumonull(null);
      setHistoricoR(null);
      setRDelete(null);
      setRelavendas(null);
      setRvenda(null);
      setRelatotal(null);
      setRelacliente(null);
    }
    if (rela=="consumo_Inadequado"){
      setConsumoExc(null);
      setConsumoInade('ds');
      setConsumonull(null);
      setHistoricoR(null);
      setRDelete(null);
      setRelatotal(null);
      setRelacliente(null);
      setRelavendas(null);
      setRvenda(null);
    }
    if (rela=="sem_consumo"){
      setConsumoExc(null);
      setConsumoInade(null);
      setConsumonull('ds');
      setHistoricoR(null);
      
      setRelacliente(null);
      setRDelete(null);
      setRelatotal(null);
      setRelavendas(null);
      setRvenda(null);
    }
    if (rela=="Registo_Clientes"){
      setConsumoExc(null);
      setConsumoInade(null);
      setConsumonull(null);
      setHistoricoR('ds');
      setRDelete(null);
      setRelatotal(null);
      setRelacliente(null);
      setRelavendas(null);
      setRvenda(null);
    }
    if (rela=="Calcelamento"){
      setConsumoExc(null);
      setConsumoInade(null);
      setConsumonull(null);
      setHistoricoR(null);
      setRDelete('ds');
      setRelatotal(null);
      setRelacliente(null);
      setRelavendas(null);
    }
    if (rela=="vendas_registo"){
      setConsumoExc(null);
      setConsumoInade(null);
      setConsumonull(null);
      setHistoricoR(null);
      setRDelete(null);
      setRelatotal(null); 
      setRelacliente(null);
      setRelavendas('ds');
    }
    if (rela=="comprasdf"){
      setConsumoExc(null);
      setConsumoInade(null);
      setConsumonull(null);
      setHistoricoR(null);
      setRDelete(null);
      setRelacliente('ds');
      setRelavendas(null);
      setRelatotal(null);
    }
    if (rela=="total_vendas"){
      setConsumoExc(null);
      setConsumoInade(null);
      setConsumonull(null);
      setHistoricoR(null);
      setRDelete(null);
      setRelacliente(null);
      setRelavendas(null);
      setRelatotal('ds');
    }
  
    


    
  }
  const consumoHandler=(e)=>{
    
  }

  const[sidebar,setSidebar]=useState(false);
  const showSidebar=()=>setSidebar(!sidebar);
    return <div className='Relatorio'>
         <div className='Filtrose'>
        
        <button  id="opcao" value="Nao  "  onClick={RevHandler}>Relatorios Estatisticos</button>
        <button  id="opcao" value="Nao  "  onClick={AcessHandler}>Registo de servico</button>
        <button  id="opcao" value="Nao  "  onClick={VendHandler}>Relatorio de Venda</button>
        <button  id="opcao" value="Nao  "  onClick={gerarecargaHandler}>Relatorio de geracao de Recargas</button>
        
        </div>
        {Operacoes && <div>
           <div className={`dropdown-menu ${open?'active':'inactive'}`}>
            <ul>
              <DropdownItem text={'Relatorio de Cobranca '} handler={CobHandler}/>
              <DropdownItem text={'Relatorios de desempenho '} handler={desHandler}/>
              <DropdownItem text={'Relatorios de divida'} handler={divHandler}/>
           
            </ul>
        
           </div>
            {cobranca && <div className='rela'>
               <div  className='menu_opc'>
               {Relatoriocobranca.map((val,key)=>
          {
          return <li key={key} className="row" onClick={()=>{setRela(val.link);Handler()}}>
 <div id="icon">{val.icon}</div><div div id="title">  {val.title}</div>
              </li>;
          }
          )}
               </div>
               
          <div className='nopias'>
          {relaconsumo && <RConsumo/>}
          {relaadiqui && <RMontante/>}
          {relavolum && <Rquantidade/>}
          {relaconsumototal && <ConsumoCliente/>}
          </div>
            </div>
            }
        
          </div>}
          {divida && <div className='rela'>
                <Rdividas/>
            </div>
            }
          {desempenho && <div className='rela'>
               <div  className='menu_opc'>
               {Relatoriodesempenho.map((val,key)=>
          {
          return <li key={key} className="row" onClick={()=>{setRela(val.link);Handler()}}>
 <div div id="title">  {val.title}</div>
              </li>;
          }
          )}

               </div>
           <div className='nopias'>
          {relaConsumoExc && <RConsumoExcessivo/>}
          {relaconsumoInade && <RConsumoInade/>}
          {relaconsumonull && <RConsumonull/>}
          {relaHistoricoR && <RHistorico/>}
          {relaDelete && <RDelete/>}
          {relavendas && <Rvendas/>}
          {relacliente   &&<ConsumoCliente/>}
          
          {relatotal   &&<Rtotal/>}
          </div>  
            </div>}
            {rvenda && <div>
            <div className='Submenu'>
           <button  id="opcao" value="Nao  "  onClick={PlataformabHandler}>Venda Via Plataforma</button>
        <button  id="opcao" value="Nao  "  onClick={OperadorHandler}>Venda por operador do sistema </button>
        
     
           </div>
            {Plataforma && 
            <div className='Caixa'>




        <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/visa.png')} /></div>
                        <div id="txts">Visa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/24-hours.png')} /></div>
                        <div id="txts">Conta Movel:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/payment-method.png')} /></div>
                        <div id="txts">M pesa:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/pos-terminal.png')} /></div>
                        <div id="txts">RecargaAki:</div>
                        <div id='valor'>0 Mzn</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/transaction.png')} /></div>
                        <div id="txts">E-mola:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/token.png')} /></div>
                        <div id="txts">MKesh:</div>
                        <div id='valor'>0 Mzn</div>
                        
                    </div>
                   
            </div>
            <div className='tabela'>
            <table id='eutabela'>
            <thead>
            <tr>
            <th>Revendedor</th>
            <th>Valor Recebido</th>
            <th>Comissao Revendedor</th>
            <th>N.Vendas Realizadas</th>
            <th>N.Recargas Geradas</th>
            <th>N.Recargas Defeituosas</th>
           
            </tr>
            </thead>
    
     
    <tbody> <tr> 
            <td>M-pesa</td>
            <td>25 000.0</td>
            <td>10%</td>
            <td>20</td>
            <td>20</td>
            <td>6</td>
           
            </tr>
           </tbody>
    
            </table>
   


            </div>
            <div>

            <div className='datadefin'>
            <img  id="imagem_vendas"src={require('./images/clock.png')}  />
     
     <div>
     Inicio
     <DatePicker onChange={onChange} value={valori}/>
     </div>
     <img  id="imagem_vendas"src={require('./images/clock.png')}  />

     <div>
     Fim
     <DatePicker onChange={onChangef} value={valorf} maxDate={new Date()}/>
     </div>
     <img  id="imagem_vendas"src={require('./images/debt.png')}  />
 
 <div>Metodo de Pagamento<select id="combo" onChange={(e)=>{
                 const provincia=e.target.value;
             }}>

             
                 <option value="">NENHUM</option>
                 <option value="m-pesa">Revendedor</option>
                 <option value="m-pesa">M-PESA</option>
                 <option value="E-MOLA">E-MOLA</option>
                 <option value="RECARGAAKI">RECARGAAKI</option>
                 <option value="CONTA MOVEL">CONTA MOVEL</option>
                 <option value="OPERADOR">Visa</option>
                 <option value="OPERADOR">M-KeSH</option>
                 
             </select>
</div>
<img  id="imagem_vendas"src={require('./images/map.png')}  />
    
<div>Zona<select id="combo" onChange={(e)=>{
                 const provincia=e.target.value;
             }}>

             
                 <option value="">NENHUM</option>
                 <option value="m-pesa">Aeroporto</option>
                 
             </select>
</div>

<img  id="imagem_vendas"src={require('./images/printer.png')}  />
               
               <ReactToPrint
                       trigger={() => {
                          return <a  href="#">   
                          <button  id="opcao" value="Nao" onClick={Send} >Imprimir
                          </button>
              </a>;
                       }}
                       content={() => PrintCaixa.current}
                     />
                     <img  id="imagem"src={require('./images/excel.png')}  />
          <ReactToExcel 
                    id='opcao'
                    table='eutabela'
                    filename='Relatorios_de_consumo'
                    sheet='sheet 1'
                    buttonText='Exportar'/>
              <select id="combo" onChange={(e)=>{
                            const provincia=e.target.value;
                        }}>
         
                        
                            <option value="">NENHUM</option>
                            
                            <option value="m-pesa">M-PESA</option>
                            <option value="E-MOLA">E-MOLA</option>
                            <option value="RECARGAAKI">RECARGAAKI</option>
                            <option value="CONTA MOVEL">CONTA MOVEL</option>
                            <option value="OPERADOR">Visa</option>
                            <option value="OPERADOR">M-KeSH</option>
                            
                        </select>
            </div>
  
            </div>
            
            </div>}
            {operador && <div className='Caixa'>





    <div className='tabela'>
    <table id='eutabela'>
    <thead>
    <tr>
    <th>Operador</th>
    <th>Valor Recebido</th>
    <th>Comissao Revendedor</th>
    <th>N.Vendas Realizadas</th>
    <th>N.Recargas Geradas</th>
    <th>N.Recargas Defeituosas</th>
   
    </tr>
    </thead>


<tbody> <tr> 
    <td>M-pesa</td>
    <td>25 000.0</td>
    <td>10%</td>
    <td>20</td>
    <td>20</td>
    <td>6</td>
   
    </tr>
   </tbody>

    </table>



    </div>
    <div>

    <div className='datadefin'>
    <img  id="imagem_vendas"src={require('./images/clock.png')}  />

<div>
Inicio
<DatePicker onChange={onChange} value={valori}/>
</div>
<img  id="imagem_vendas"src={require('./images/clock.png')}  />

<div>
Fim
<DatePicker onChange={onChangef} value={valorf} maxDate={new Date()}/>
</div>
<img  id="imagem_vendas"src={require('./images/debt.png')}  />

<div>Metodo de Pagamento<select id="combo" onChange={(e)=>{
         const provincia=e.target.value;
     }}>

     
         <option value="">NENHUM</option>
         <option value="m-pesa">Revendedor</option>
         <option value="m-pesa">M-PESA</option>
         <option value="E-MOLA">E-MOLA</option>
         <option value="RECARGAAKI">RECARGAAKI</option>
         <option value="CONTA MOVEL">CONTA MOVEL</option>
         <option value="OPERADOR">Visa</option>
         <option value="OPERADOR">M-KeSH</option>
         
     </select>
</div>
<img  id="imagem_vendas"src={require('./images/map.png')}  />

<div>Zona<select id="combo" onChange={(e)=>{
         const provincia=e.target.value;
     }}>

     
         <option value="">NENHUM</option>
         <option value="m-pesa">Aeroporto</option>
         
     </select>
</div>

<img  id="imagem_vendas"src={require('./images/printer.png')}  />
       
       <ReactToPrint
               trigger={() => {
                  return <a  href="#">   
                  <button  id="opcao" value="Nao" onClick={Send} >Imprimir
                  </button>
      </a>;
               }}
               content={() => PrintCaixa.current}
             />
             <img  id="imagem"src={require('./images/excel.png')}  />
  <ReactToExcel 
            id='opcao'
            table='eutabela'
            filename='Relatorios_de_consumo'
            sheet='sheet 1'
            buttonText='Exportar'/>
      <select id="combo" onChange={(e)=>{
                    const provincia=e.target.value;
                }}>
 
                
                    <option value="">NENHUM</option>
                    
                    <option value="m-pesa">M-PESA</option>
                    <option value="E-MOLA">E-MOLA</option>
                    <option value="RECARGAAKI">RECARGAAKI</option>
                    <option value="CONTA MOVEL">CONTA MOVEL</option>
                    <option value="OPERADOR">Visa</option>
                    <option value="OPERADOR">M-KeSH</option>
                    
                </select>
    </div>

    </div>
    
    </div>}
          </div> }

          {Acessois && <div className='rela'>
               <div  className='menu_opc'>
            {RegistoOperacoes.map((val,key)=>
          {
          return <li key={key} className="row" onClick={()=>{setRela(val.link);Handler()}}>
 <div div id="title">  {val.title}</div>
              </li>;
          }
          )}
          </div>
          <div className='nopias'>
          {relaHistoricoR && <RHistorico/>}
          {relavendas && <Rvendas/>}
          
          {relatotal   &&<Rtotal/>}
          </div>  
           
          </div>
          }
          {VendaRecarga && <div className='Recargas'>
          {tokens &&
        <div className='subinfo'>
                        
        <table id="tabela-recargass">
    <thead>
      
      <tr>
      <th>Nome </th>
        <th>Numro de Contador</th>
        <th>Token</th>
        <th>Valor Pago</th>
        <th>Metros cubicos</th>
        <th>Iva</th>
        <th>Taxa</th>
        <th>Data de Geracao</th>
        <th>Metodo de Pagamento</th>
        <th>Plataforma</th>
        <th>Primavera ID</th>
        
         </tr>
    </thead>
    {tokens && <tbody> {SearchD(Search(tokens)).map((ct,key)=>{
         return  <tr> 
         <td>{dados.nome}</td>
         <td>{ct.numero_contador}</td>
         <td>{ct.numero_token}</td>
         <td>{ct.valor_pago}</td>
        <td>{ct.metroscubicos}</td>
        <td>{ct.iva}</td>
        <td>{ct.tsc}</td>
        <td>{ct.data_de_compra}</td>
        <td>{ct.metodo}</td>
        <td>Web</td>
        <td>{ct.primavera}</td>
         </tr>
     
      })}</tbody>}
            
  </table>                  
        
      
             </div>
                

        }
               
               {tokens && <div className='clienteaccoes'>
        <img  id="imagem"src={require('./images/printer.png')}  />
                    <ReactToPrint
          trigger={() => {
             return <a  href="#">   
             <button  id="opcao" value="Nao" onClick={Send} >Imprimir
             </button>
 </a>;
          }}
          content={() => printContents.current}
        />
            
            <img  id="imagem"src={require('./images/excel.png')}  />
            <ReactToExcel 
                    id='opcao'
                    table='tabela-recargass'
                    filename='Contadores_Cliente_Recargas'
                    sheet='sheet 1'
                    buttonText='Exportar'/>
   <img  id="imagem"src={require('./images/filter.png')}  />
              
              <button  id="opcao" value="Nao" onClick={Send} >Filtros
              </button>
              <h3>Inicio</h3>
              <input type='date' onChange={(e)=>{
                  setDiaAno(e.target.value)
              }}/>
              <h3>Fim</h3>
              
               <input type='date' onChange={(e)=>{
                   setDianofim(e.target.value)
              }}/>
                   <select id="combo" onChange={(e)=>{
                            const provincia=e.target.value;
                            console.log(provincia)
                            setData(provincia);
                        }}>
         
                        
                            <option value="">NENHUM</option>
                            
                            <option value="m-pesa">M-PESA</option>
                            <option value="E-MOLA">E-MOLA</option>
                            <option value="RECARGAAKI">RECARGAAKI</option>
                            <option value="CONTA MOVEL">CONTA MOVEL</option>
                            <option value="OPERADOR">OPERADOR</option>
                        </select>
                       
                   
            </div>}      
            
            </div>}
         
    </div>;
}
function DropdownItem(props){
  return(
    <li className='dropdown_item' onClick={props.handler}>
       <a>{props.text}</a>
  
    </li>
  
  )
} 

export default AGestRelatorios